import $ from 'domtastic';

class Navigation {
  static calculateSpring(itemElement, innerElement, textElement) {
    const innerHalf = Number((innerElement.offsetWidth / 2) - (textElement.offsetWidth / 2));
    const offsetLeft = Number(itemElement.offsetLeft - innerHalf);
    const windowWidth = Number(window.innerWidth);
    const offsetLeftPercent = Number(100 * (offsetLeft / windowWidth));

    return offsetLeftPercent;
  }

  static resizeSpring($item) {
    const $spring = $item.find('.js-nav-sub-spring');
    const $text = $item.find('span');
    const $inner = $item.find('.js-nav-sub-inner');

    const offsetLeft = Navigation.calculateSpring($item[0], $inner[0], $text[0]);
    $spring.attr('style', `flex-basis: ${offsetLeft}%;`);
  }

  constructor() {
    this.cacheDom();
    this.bindEvents();
  }

  cacheDom() {
    this.$item = $('.js-nav-item');
    this.$sub = $('.js-nav-sub');
    this.$subInner = $('.js-nav-sub-inner');
    this.$spring = $('.js-nav-spring');
  }

  bindEvents() {
    this.$item.on('mouseenter', (event) => {
      const $item = $(event.currentTarget);
      this.isHovering = true;
      this.handleHover($item);
    });

    this.$item.on('mouseout', (event) => {
      const toElement = event.toElement || event.relatedTarget;
      const $item = $(toElement).closest('.js-nav-item');
      if ($item[0]) return;
      this.isHovering = false;
      this.handleOut(this.$item);
    });
  }

  handleOut($item) {
    setTimeout(() => {
      if (!this.isHovering) this.toggleHover($item, false);
    }, 500);
  }

  // Handle hovering nav items
  handleHover($item) {
    Navigation.resizeSpring($item);
    this.toggleHover($item, true);
  }

  toggleHover($item, isHovered) { // eslint-disable-line
    $item.toggleClass('-hover', isHovered);
  }
}

export default new Navigation();



// WEBPACK FOOTER //
// ./components/Navigation.js